import { User } from './../user-details-forum/user-details-forum.component';
import { BadgeServiceService } from './../services/badgeService/badge-service.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, PatternValidator } from '@angular/forms';

interface Card {
  cardNo: number,
  name: string,
  cvc: string,
  expiryDateMM: string,
  expiryDateYYYY: string
}

@Component({
  selector: 'app-checkout-form',
  templateUrl: './checkout-form.component.html',
  styleUrls: ['./checkout-form.component.css']
})

export class CheckoutFormComponent implements OnInit {

  firstStepGroup: FormGroup;
  users: User[] = [];
  price: number = 0;

  card: Card = {
    //Testing
    //cardNo: 4444333322221111,
    //Live
    cardNo: 4444333322221111,
    name: "Tommy testing",
    cvc: "222",
    expiryDateMM: "10",
    expiryDateYYYY: "2023"
  };

  isSuccess: boolean = false;
  processing: boolean = false;

  orderDetails: any;

  constructor(private _formBuilder: FormBuilder, private _badgeService: BadgeServiceService) { }

  ngOnInit(): void {
    this.firstStepGroup = this._formBuilder.group({
      cardNo: ['', Validators.required],
      name: ['', Validators.required],
      cvv: ['', Validators.required],
      expiryDateMM: ['', Validators.required,],
      expiryDateYYYY: ['', Validators.required]
    });
    this.users = this._badgeService.users;
    this.price = this.users.length * 0;
    console.log(this.users.length);
  }

  takePayment(): void {
    this.processing = true;
    //console.log (this.card)
    // Split Expiry Date
    //var splitDate = this.card.expiryDate.split("/");
     var obj = {
      "transactionReference": "PA" + Math. floor((Math. random() * 1000000) + 1),
      "merchant": {
        //live
        "entity": "WEASSOC"
        //Testing
        //"entity": "default"
      },
      "instruction": {
        "narrative": {
          "line1": "WEA"
        },
        "value": {
          "currency": "GBP",
          "amount": 0 * this.users.length
        },
        "paymentInstrument": {
          "type": "card/plain",
          "cardNumber": this.card.cardNo.toString(),
          "cardExpiryDate": {
            "month": parseInt(this.card.expiryDateMM),
            "year": parseInt(this.card.expiryDateYYYY)
          },
          "cvc": this.card.cvc
        }
      }
    };
    //console.log("takePayment");
    this._badgeService.sendPaymentRequest(obj).subscribe((data) => {
     // console.log(data);
      this.isSuccess = (data.outcome === "success") ? true : false;
      this.orderDetails = data;
      if (this.isSuccess){
        this.insertOrders();
      }
      
    })
  }

  insertOrders(): void {
    var orders = [];
    this.users.forEach((user => {
      //console.log(user)
      //console.log(user.image);
      orders.push({
        "authorisationCode": this.orderDetails.authorisationCode,
        "transactionReference": this.orderDetails.transactionReference,
        "employer": user.employerName,
        "employerAddress": user.address,
        "personalAssistant": user.paName,
        "price": 0,
        "paImage": user.image,
        "employerEmail": user.email,
        "county": user.county
      });
    }));
    //console.log(orders);
    this._badgeService.insertOrders(orders).subscribe((data) => {
      //console.log("Insert orders");
      //console.log(data);
      this.processing = false;
      this._badgeService.users =[];
      this._badgeService.usersObservable.next (this._badgeService.users);

      // setInterval(() => {
      //   document.location.reload();
      //    window.location.href= 'https://www.panetworkscotland.org.uk/'
      // },10000)
      
     
    });
  }

}